import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { VideoService } from '../../../services/video.service';
import { group_by_item_count } from '../../../../functions';

@Component({
  selector: 'app-home-videos-section',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, NgbCarouselModule],
  templateUrl: './home-videos-section.component.html',
})
export class HomeVideosSectionComponent {
  videos: any[] = [];

  constructor(public videoService: VideoService) {
    this.videoService.setHomeData();

    this.videos = this.videoService.homeData;
    if (this.videos.length === 0) {
      this.videoService.$homeDataSubject.subscribe(() => {
        this.videos = this.videoService.homeData;
        this.videos = group_by_item_count(this.videos, 2);
      });
    } else {
      this.videos = group_by_item_count(this.videos, 2);
    }
  }
}
